import React from "react";
import * as _ from "lodash";
import MainTitle from "../common/MainTitle";
import ResourceResume from "./ResourceResume";
import CustomHr from "../common/CustomHr";
import { translate } from "utlis/translations/i18n";

const ResourceResumes = ({ results, playedTimes, selectedName }) => {
  return (
    <div>
      {results.map((res, i) => {
        const resultsDsc = _.orderBy(res.results, ["points"], ["desc"]);
        return (
          <div key={i}>
            <MainTitle
              text={
                <span>
                  {translate('sequence')} {i + 1}: <br /> {res.sequenceContext}{" "}
                </span>
              }
            />
            <div className="row margin-bottom-large">
              {resultsDsc.map((singleResult, y) => {
                // Si selectedName est défini et que le tableau voters de singleResult contient selectedName
                if (!selectedName || (singleResult.voters && singleResult.voters.includes(selectedName))) {
                  return (
                    <ResourceResume
                      key={`${i}-${y}`}
                      result={singleResult}
                      rank={y + 1}
                      maximum={playedTimes}
                      selectedName={selectedName}
                    />
                  );
                }
                return null; // Retourne null si la condition n'est pas remplie
              })}
            </div>
            <p>
              *{translate('manuChVotesDesc')}{" "}
            </p>
            <p className="margin-bottom-large">
              **{translate('manuChScoreDesc')}
            </p>
            <CustomHr />
          </div>
        );
      })}
    </div>
  );
};

export default ResourceResumes;
